// extracted by mini-css-extract-plugin
export var connectWalletButton = "Gr3V7mzTX7Q8wWq5Ol6I";
export var connectedAccount = "E_mStcaHRK8FBoA9m7_P";
export var connectedAccountContainer = "o1oudjktMbede5xEMk4M";
export var connectedAccountIcon = "fjElR27Unbg3zc5zYJ6E";
export var logoutButton = "wj1onzNZuHApQ7Zak4q5";